import React from "react";
import R14, {
  Text,
  DataTable,
  Platform,
  View,
  SafeAreaView,
} from "../core";
import Touchable from "../components/TouchableComponent";
import NoRecordsFound from "./NoRecordsFound";
import CommonUtility from "../utils/CommonUtility";
import DateUtils from "../utils/DateUtils";
import { commonStyles } from "../assets/css/commonStyle";
import { gridTableStyles } from "../assets/css/gridTableStyles";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import { BILL_STATUS } from "../constant/app.data.constant";
import Bookmarked from "./Bookmared";
export default R14.connect(
  class DashboardGridTableComponent extends React.Component {
    constructor(props) {
      super(props);
      this.handleDeleteClientPress = this.handleDeleteClientPress.bind(this);
      this.handleAddClientPress = this.handleAddClientPress.bind(this);
      this.initializer = this.initializer.bind(this);
      this.pageLoader = this.pageLoader.bind(this);
      this.cellRenderer = this.cellRenderer.bind(this);
      this.rowKeyExtractor = this.rowKeyExtractor.bind(this);
    }

    async initializer(gridState) {
      this.props.app.dm.userSession.setState({isLoading: true});
      const data = await this.props.getPageData(gridState, { totalCount: true });
      this.props.app.dm.userSession.setState({isLoading: false});
      return data;
    }
    async pageLoader(gridState) {
      let res = await this.props.getPageData(gridState, { totalCount: true }, false);
      return res.pageData;
    }
    get dataTable() {
      return this.props.app.ui.dataTable("clients");
    }

    shortenText = (txt = "", limit = 30) => {
      if (!!txt && !isNaN(txt) && !Number.isInteger(+txt)) {
        const num = +txt;
        return num.toFixed(2);
      } else if (!!txt && txt.length > limit) {
        return txt.substring(0, limit) + '...';
      } else {
        return txt;
      }
    };

    getNestedProperty(obj, path) {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }

    renderDashboardCellRenderer(e) {
      const { columns, columnName, row } = e;
      const { amountTypeFields, dateTypeFields, profileIcon, showPayType, CheckPaymentAllowOrNot, toggleBookmark, onProfileIcon } = this.props;
      let text = row[columnName];

      if (columns && columns[columnName] && columns[columnName].label === "Action") {
        return (
          <Touchable onPress={() => showPayType(row)} style={[gridTableStyles.zIndex2]} disabled={!CheckPaymentAllowOrNot(row)}>
            <View style={[responsiveTableStyle.paynowBtnInnerWrap, customCommonStyles.customPaynowBtnInnerWrap, Platform.OS !== "web" ? commonStyles.paddingTop3 : null, !CheckPaymentAllowOrNot(row) ? customCommonStyles.disabledBtn : null]}>
              <Text style={[commonMetricsStyle.heading6, commonStyles.fontWeight500, commonFontStyles.workSans, commonStyles.textAlignCenter, commonStyles.fullWidth, commonStyles.fontWeight400, commonStyles.exSmallHeading, commonStyles.flex1, commonStyles.justifyContentCenter, commonStyles.alignItemCenter, !CheckPaymentAllowOrNot(row) ? commonStyles.lightGray : commonStyles.whiteColor]}>Pay Now</Text>
            </View>
          </Touchable>
        );
      }

      if (columnName === "bookmark") {
        return <View >
          {!BILL_STATUS[row.billStatus] && !(row.status === "blocked" || row.status === "payerblocked") ? (
            <Bookmarked
              bookedMarkSpacing={responsiveTableStyle.bookedMarkSpacing}
              onToggle={() => {
                toggleBookmark(row);
                this.refreshDataTable();
              }}
              isBookmarked={row.bookmark}
              bookedMarkImgStyle={[commonStyles.marLT0]}
              bookedMarkStyle={[gridTableStyles.btnHeight]}
            />
          ) : null}
        </View>
      }

      if (profileIcon === columnName) {
        if (columnName.includes(".")) text = this.getNestedProperty(row, columnName);
        return (
          <Touchable onPress={() => onProfileIcon(row)}>
          <View style={[commonStyles.flex1, commonStyles.flexDirectionRow]}>
            <View style={[responsiveTableStyle.userIconDiv, commonStyles.flex1, commonStyles.justifyContentCenter, commonStyles.alignItemsCenter, commonStyles.marLT0, commonStyles.marT0, commonStyles.marB0, commonStyles.marginRight5]}>
              <Text
                style={[
                  commonStyles.fontWeight500,
                  commonFontStyles.workSans,
                  commonStyles.exSmallHeading,
                  commonStyles.userInitial,
                  commonStyles.contentColor,
                  responsiveTableStyle.userInitial,
                  commonStyles.dBlock
                ]}>
                {CommonUtility.shortName(`${text}`)}
              </Text>
            </View>
            <Text style={[commonFontStyles.workSans, gridTableStyles.cellText]}>{this.shortenText(text)} </Text>
          </View>
          </Touchable>
        )
      }

      if (!!amountTypeFields && amountTypeFields.length && amountTypeFields.includes(columnName)) {
        text = row[columnName] ? this.shortenText(CommonUtility.formatAmount(row[columnName], this.props.app)) : CommonUtility.formatAmount("0.00", this.props.app);
      } else if (!!dateTypeFields && dateTypeFields.length && dateTypeFields.includes(columnName)) {
        text = DateUtils.dataTableDateFormatter(row[columnName]);
      } else if (columnName.includes(".")) {
        text = this.getNestedProperty(row, columnName)
      }
      return <Text style={[commonFontStyles.workSans, gridTableStyles.cellText]}>{this.shortenText(text)} </Text>
    }

    cellRenderer(e) {
      return this.renderDashboardCellRenderer(e);
    }
    rowKeyExtractor(row) {
      return row.uid;
    }

    async handleAddClientPress() {
      this.props.app.nav.to("addClientRoute", {
        mode: "add"
      })
    }

    async handleDeleteClientPress(uid) {
      this.props.app.ui.progressIndicator.show();
      this.props.app.ui.progressIndicator.hide({ timeout: 750 });
    }

    async handleBookmarkSyncPress(row, dataTable) {
      await this.props.toggleBookmark(row);
      this.refreshDataTable();
      return false;
    }

    refreshDataTable = () => {
      this.dataTable.refresh();
      this.props.app.dm.userSession.setState({isLoading: true});
      return false;
    };


    render() {
      const { name, labelKeys, labelValues, message, searchable, rowControlsRight, autoRefresh = 0, headerControlsRight = null, rowsPerPage = 10, headerTitleTextStyle = null } = this.props;
      const columns = {};
      labelKeys.forEach((keyObj, index) => {
        const key = labelValues[index];
        columns[key] = {
          label: keyObj.label,
          ...(keyObj.sortable !== undefined ? { sortable: keyObj.sortable } : {}),
          ...(keyObj.width !== undefined ? { width: keyObj.width } : {}),
          ...(keyObj.cellStyle ? { cellStyle: keyObj.cellStyle } : {})
        };
      });

      return (
        <SafeAreaView style={[gridTableStyles.screenLayout, commonStyles.widthAuto]}>
          <DataTable
            name={name}
            columns={columns}
            searchable={searchable}
            initializer={this.initializer}
            rowKeyExtractor={this.rowKeyExtractor}
            pageLoader={this.pageLoader}
            TableEmptyComponent={<NoRecordsFound noRecords={[commonStyles.marLT0, commonStyles.marRT0]} message={message} />}
            cellRenderer={(e) => this.cellRenderer(e)}
            initialPage={1}
            initialRowsPerPage={rowsPerPage}
            initialTotalRows={rowsPerPage}
            initialSortColumnName='type'
            initialSortDirection='asc'
            // onRowPress={(item) => onProfileIcon(item)}
            autoRefresh={autoRefresh}
            headerControlsRight={headerControlsRight}
            headerTitle={this.props.title || null}
            headerTitleTextStyle={[gridTableStyles.headerTitleTextStyle, headerTitleTextStyle]}
            rowControlsRight={!rowControlsRight ? null : (row, dataTable) => {
              return rowControlsRight
            }}
          /> </SafeAreaView>
      );
    }
  }
);